export const getRandomInArray = (array) => {
  if (!array || !array.length) {
    return
  }
  return array[Math.floor(Math.random() * array.length)]
}



// WEBPACK FOOTER //
// ./src/utilities/arrays.js